import IndexPanelContent from './IndexPanelContent';

export default IndexPanelContent;